import { Popover } from 'react-bootstrap';
import PT from 'prop-types';
import { UniqueOverlayTrigger } from 'edrolo/domains/overlays';
import DeleteSittingButton from './DeleteSittingButton';
import DeleteSittingOverlay from './DeleteSittingOverlay';

import styles from './styles.scss';

const Component = (props) => (
  <UniqueOverlayTrigger
    trigger="click"
    placement="bottom"
    rootClose
    uniqueOverlayId={`delete-sitting-${props.sittingId}`}
    renderOverlay={(overlayControl) => (
      <Popover
        className={styles.deletePopover}
        id="delete-exam-sitting-popover"
      >
        <DeleteSittingOverlay overlayControl={overlayControl} {...props} />
      </Popover>
    )}
  >
    <DeleteSittingButton isShown={props.showControl} />
  </UniqueOverlayTrigger>
);

export default Component;

Component.propTypes = {
  sittingId: PT.oneOf([PT.string, PT.number]),
  showControl: PT.bool,
};
